const footerHeight = () => {
    const homePage = document.querySelector('.template-index');

    if(!homePage) return;

    const footerSections = document.querySelectorAll('.shopify-section-group-group-footer')
    
    const updateFooterHeight = () => {
        let totalHeight = 0;
        footerSections.forEach(section => {
            totalHeight += section.offsetHeight;
        });
        document.documentElement.style.setProperty('--custom-footer-height', `${totalHeight}px`);
    }

    const observer = new ResizeObserver(entries => {
        updateFooterHeight();
    })

    footerSections.forEach(section => {
        observer.observe(section);
    })
}
document.addEventListener("DOMContentLoaded", footerHeight);
document.addEventListener('shopify:section:load', footerHeight);


const variantSelectorOverlay = () => {
    const radioBtns = document.querySelectorAll('.product-single .radio__button, .product-single .product__subs__group');
    if(radioBtns.length < 1) return;

    radioBtns.forEach(btn => {
        const svg = btn.querySelector('.icon-variant-selector-overlay');
        if(!svg) return;

        const width = btn.offsetWidth;
        const height = btn.offsetHeight;
        const aspectRatio = width / height;

        const baseRotation = -12.954;
        const targetRatio = 1;
        const rotationAdjustment = (aspectRatio - targetRatio) * 2;
        const rotation = baseRotation + rotationAdjustment;

        svg.style.transform = `translate(-50%, -50%) rotate(${rotation}deg)`;
    })
}
const initVariantOverlay = () => {
    variantSelectorOverlay();
    
    if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
        window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, variantSelectorOverlay);
    }
};
document.addEventListener("DOMContentLoaded", initVariantOverlay);
document.addEventListener('shopify:section:load', initVariantOverlay);


const ingredientsPopup = () => {
    const ingredientsCtr = document.querySelector('.section-ingredients-nutrition');
    if(!ingredientsCtr) return;

    const btn = ingredientsCtr.querySelector('.btn--ingredients');
    if(!btn) return;
    
    const overlay = ingredientsCtr.querySelector('.ingredients-nutrition-overlay');
    const popup = ingredientsCtr.querySelector('.ingredients-nutrition-popup');
    const closeBtn = ingredientsCtr.querySelector('.ingredients-nutrition-popup .icon-close');

    const isActive = () => overlay.classList.contains('active') && popup.classList.contains('active');

    const openPopup = () => {
        if(!isActive()) {
            overlay.classList.add('active');
            popup.classList.add('active');
        }
    }

    const closePopup = () => {
        if(isActive()) {
            overlay.classList.remove('active');
            popup.classList.remove('active');
        }
    }

    btn.addEventListener('click', (e) => {
        e.preventDefault();
        openPopup();
    })

    closeBtn.addEventListener('click', () => {
        closePopup();
    })

    overlay.addEventListener('click', () => {
        closePopup();
    })

    document.addEventListener('keydown', (e) => {
        if(e.key === 'Escape') {
            closePopup();
        }
    })
}
document.addEventListener("DOMContentLoaded", ingredientsPopup);
document.addEventListener('shopify:section:load', ingredientsPopup);


const floatingImagesRotate = () => {
    const images = document.querySelectorAll('[class*="pdp-float-image-"], [class*="page-float-image-"]');
    if(!images.length) return;

    const MAX_ROTATION = 50;

    let scrollPosition = window.scrollY;

    const isInView = (element) => {
        const rect = element.getBoundingClientRect();
        const threshold = 150;
        return (
            rect.top < (window.innerHeight - threshold) && 
            rect.bottom > threshold
        );
    }

    const getRotationDirection = (element) => {
        const classList = Array.from(element.classList);
        const floatClass = classList.find(cls => 
            cls.includes('pdp-float-image-') || cls.includes('page-float-image-')
        );
        
        if(!floatClass) return 1;
        
        const match = floatClass.match(/-(\w+)$/);
        const suffix = match ? match[1] : '';
        
        const numberMap = {
            'one': 1, 'two': 2, 'three': 3, 'four': 4, 
            'five': 5, 'six': 6, 'seven': 7, 'eight': 8,
            'nine': 9, 'ten': 10
        };
        
        const num = numberMap[suffix] || 1;
        const isLeft = num % 2 === 1;
        const positionInColumn = Math.floor((num - 1) / 2);
        
        if(isLeft) {
            return (positionInColumn % 2 === 0) ? 1 : -1;
        } else {
            return (positionInColumn % 2 === 0) ? -1 : 1;
        }
    }

    const handleScroll = () => {
        const currentScroll = window.scrollY;
        const scrollDelta = currentScroll - scrollPosition;
        scrollPosition = currentScroll;

        images.forEach((image) => {
            if(!isInView(image)) return;

            const direction = getRotationDirection(image);
            const currentRotation = parseFloat(image.style.transform.replace(/[^-\d.]/g, '')) || 0;
            
            const rotationChange = scrollDelta * 0.1 * direction;
            let newRotation = currentRotation + rotationChange;
            
            newRotation = Math.max(-MAX_ROTATION, Math.min(MAX_ROTATION, newRotation));
            
            image.style.transform = `rotate(${newRotation}deg)`;
        });
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
}

document.addEventListener("DOMContentLoaded", floatingImagesRotate);
document.addEventListener('shopify:section:load', floatingImagesRotate);


let lastVariantId = null;
const subPriceUpdate = (e) => {
    const variant = e.data.variant;
    if (!variant) return;

    const variantChanged = lastVariantId !== null && lastVariantId !== variant.id;
    lastVariantId = variant.id;
    
    if (variantChanged) {
        const oneTimePurchaseRadio = document.querySelector('input[name="selling-plan-group"][value=""]');
        if (oneTimePurchaseRadio && !oneTimePurchaseRadio.checked) {
            oneTimePurchaseRadio.checked = true;
            oneTimePurchaseRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    const selectedPlanGroup = document.querySelector('input[name="selling-plan-group"]:checked');
    const hasPlanSelected = selectedPlanGroup && selectedPlanGroup.value !== '';
    
    const priceWrappers = document.querySelectorAll('[data-price-wrapper]');
    
    priceWrappers.forEach((wrap) => {
        const comparePriceEl = wrap.querySelector('[data-compare-price]');
        const productPriceEl = wrap.querySelector('[data-product-price]');
        
        let comparePrice = variant.compare_at_price;
        let price = variant.price;
        let planSale = false;
        
        if (hasPlanSelected && variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
            const allocation = variant.selling_plan_allocations[0];
            price = allocation.per_delivery_price;
            
            if (variant.price > allocation.per_delivery_price) {
                planSale = true;
                comparePrice = variant.price;
            }
        }
        
        const formatPrice = (val) => {
            return window.theme?.formatMoney 
                ? window.theme.formatMoney(val, theme.moneyFormat) 
                : (val / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        };
        
        if (productPriceEl) {
            productPriceEl.innerHTML = price === 0 ? window.theme.strings.free : formatPrice(price);
        }
        
        if (comparePriceEl) {
            const showCompare = (comparePrice && comparePrice > price);
            
            if (showCompare) {
                comparePriceEl.classList.remove('hidden');
                productPriceEl.classList.add('product__price--sale');
                comparePriceEl.innerHTML = formatPrice(comparePrice);
            } else {
                comparePriceEl.classList.add('hidden');
                productPriceEl.classList.remove('product__price--sale');
            }
        }
    });
    
    const productForm = e.target?.querySelector('.product-single .product__block[data-form-wrapper]') 
        || document.querySelector('.product-single .product__block[data-form-wrapper]');

    if (productForm) {
        const oneTimeEl = productForm.querySelectorAll('[data-one-time-price]');
        const discountEl = productForm.querySelectorAll('[data-discount-price]');
        const variantPrice = variant.price;
        const discountPrice = variant.selling_plan_allocations?.[0]?.per_delivery_price;

        const formatPriceCustom = (val) => {
            const formatted = (val / 100).toLocaleString('en-US', {
                style: 'currency', 
                currency: 'USD'
            });
            return formatted.replace('$', '$ ');
        };

        oneTimeEl.forEach(priceEl => {
            priceEl.innerText = formatPriceCustom(variantPrice);
        });

        if (discountPrice) {
            discountEl.forEach(priceEl => {
                priceEl.innerText = formatPriceCustom(discountPrice);
            });
        }
    }
};
const handlePlanGroupChange = (e) => {
    const val = e.target.value.toString();
    const selected = document.querySelector(`[data-group-toggle="${val}"]`);
    const groups = document.querySelectorAll('[data-group-toggle]');
    
    if (selected) {
        selected.classList.remove('hidden');
        const first = selected.querySelector('[name="selling_plan"]');
        if (first) {
            first.checked = true;
            first.dispatchEvent(new Event('change'));
        }
    }
    
    groups.forEach((group) => {
        if (group !== selected) {
            group.classList.add('hidden');
            const plans = group.querySelectorAll('[name="selling_plan"]');
            plans.forEach((plan) => {
                plan.checked = false;
                plan.dispatchEvent(new Event('change'));
            });
        }
    });
    
    const currentVariant = getSelectedVariant();
    if (currentVariant) {
        subPriceUpdate({ data: { variant: currentVariant } });
    }
};
let subscriptionId = null;
const initSubscription = () => {
    const currentVariant = getSelectedVariant();
    if (currentVariant) {
        lastVariantId = currentVariant.id;
    }
    
    if (subscriptionId && window.unsubscribe) {
        window.unsubscribe(subscriptionId);
    }
    
    if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
        subscriptionId = window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, subPriceUpdate);
    }
    
    const planGroupRadios = document.querySelectorAll('input[name="selling-plan-group"]');
    planGroupRadios.forEach(radio => {
        radio.addEventListener('change', handlePlanGroupChange);
    });
};
const getSelectedVariant = () => {
    const variantData = document.querySelector('[data-selected-variant]');
    return variantData ? JSON.parse(variantData.innerHTML) : null;
};
document.addEventListener("DOMContentLoaded", initSubscription);
document.addEventListener('shopify:section:load', initSubscription);



window.addEventListener('scroll', function() {
  const header = document.querySelector('#SiteHeader');
  const footer = document.querySelector('.footer-bottom__left');
  // Get the original top position of the header
  const headerOffsetTop = header.offsetTop;

  if (window.pageYOffset > headerOffsetTop) {
    footer.classList.add('is-fixed');
  } else {
    footer.classList.remove('is-fixed');
  }
});


if (document.body.classList.contains('template-product')) {
  
  window.addEventListener('scroll', function() {
    if (window.scrollX !== 0) {
      window.scrollTo(0, window.scrollY);
    }
  }, { passive: true });
  
  let startX, startY;
  
  document.addEventListener('touchstart', function(e) {
    startX = e.touches[0].pageX;
    startY = e.touches[0].pageY;
  }, { passive: true });
  
  document.addEventListener('touchmove', function(e) {
    const deltaX = Math.abs(e.touches[0].pageX - startX);
    const deltaY = Math.abs(e.touches[0].pageY - startY);
    
    if (deltaX > deltaY) {
      e.preventDefault();
    }
  }, { passive: false });
  
}